import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import BuyButton from './ListBuyButton';
import { translate } from '../../Services/translation';
import VariantNotification from './VariantNotification';
import {
  clearErrorMessage,
  setErrorMessage,
  setMessage,
} from '../../Actions/ProductDetail.action';
import { useDispatch, useSelector } from 'react-redux';
import constants from '../../constants';

const RegularVariantData = ({
  productName,
  logos,
  type,
  comment,
  variants,
  isOrderItem,
  isBundle,
  configurableVariantId
}) => {
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [minQuantity, setMinQuantity] = useState(
    variants.length === 1 ? variants[0].minQuantity : 1
  );
  const [quantity, setQuantity] = useState(
    variants.length === 1 ? variants[0].minQuantity : 1
  );
  const dispatch = useDispatch();
  const isViewOnlyUser = constants.isViewOnlyUser;

  const cart = useSelector((state) => state.cart);
  let variant = variants[0];

  function checkAvailableStock(newTotal) {
    let rows = cart.orderRows.filter(
      (x) => x.articleNumber === variant.variantId
    );

    if (isOrderItem) {
      return true;
    }

    if (rows === 0) {
      return newTotal <= variant.stockQuantity;
    }

    let amount = rows.reduce((sum, x) => sum + x.quantity, 0);

    if (amount + newTotal > variant.stockQuantity) {
      dispatch(
        setMessage({
          message: translate('product-variant.notification.error.exceedsstock'),
          type: 'error',
        })
      );

      return false;
    }

    return true;
  }

  useEffect(() => {
    setMessage('');
  }, [quantity]);

  function decrement() {
    let newTotal = quantity - variant.minQuantity;

    if (newTotal > 0) {
      setQuantity(newTotal);

      return;
    }

    dispatch(
      setErrorMessage(
        translate('product-variant.notification.error.minquantity')
      )
    );
  }

  function increment() {
    let newTotal = quantity + variant.minQuantity;
    if (isOrderItem) {
      setQuantity(newTotal);
      return;
    }
    if (newTotal <= variants[0].stockQuantity) {
      if (checkAvailableStock(newTotal)) {
        setQuantity(newTotal);
      }

      return;
    }

    dispatch(
      setErrorMessage(
        translate('product-variant.notification.error.maxquantity')
      )
    );
  }

  if (isViewOnlyUser) {
    return (
      <div className="product-variant__bottom-container">
        <button className="product-variant__styled-button product-variant__buy-button">
          {translate('product-variant.viewonlyuser.message')}
        </button>
        <span className="product-variant__shipping-container">
          <img
            className="product-variant__shipping-icon"
            src="/ui/images/fast-delivery-black.svg"
            alt=""
          />
          <p className="product-variant__shipping-text">
            {translate('product.shipping.time')}
          </p>
        </span>
      </div>
    );
  }

  return (
    <>
      <VariantNotification />

      <div className="product-variant__bottom-container">
        <div className="product-variant__input-container">
          <div className="product-variant__single-input-container">
            <button
              className="product-variant__single-input-button"
              onClick={() => decrement()}
            >
              -
            </button>
            <input
              className="product-variant__single-input"
              readOnly={minQuantity > 1}
              onChange={(e) => {
                let number = +e.target.value;
                if (number >= 1) {
                  setQuantity(number);
                }
              }}
              type="number"
              value={quantity}
            />
            <button
              className="product-variant__single-input-button"
              onClick={() => increment()}
            >
              +
            </button>
          </div>

          <BuyButton
            label={translate('products.add.to.cart', totalQuantity)}
            exceedsStock={
              isOrderItem ? false : variant.stockQuantity < quantity
            }
            comment={comment}
            productName={productName}
            items={[
              {
                articleNumber: variants[0].variantId,
                quantity: quantity,
              },
            ]}
            type={type}
            logos={logos}
            cssClass="product-variant__styled-button product-variant__buy-button"
						isBundle={isBundle}
						configurableVariantId={configurableVariantId}
          ></BuyButton>
        </div>
        <span className="product-variant__shipping-container">
          <img
            className="product-variant__shipping-icon"
            src="/ui/images/fast-delivery-black.svg"
            alt=""
          />
          <p className="product-variant__shipping-text">
            {translate('product.shipping.time')}
          </p>
        </span>
      </div>
    </>
  );
};

export default RegularVariantData;
